import api from './api';

const prospectionApi = {
  // Recherche live via API SIRENE
  search: (params = {}) => api.get('/prospection/search', { params }),

  // Recherches sauvegardées
  getRecherches: () => api.get('/prospection/recherches'),
  getRecherche: (id) => api.get(`/prospection/recherches/${id}`),
  saveRecherche: (data) => api.post('/prospection/recherches', data),
  deleteRecherche: (id) => api.delete(`/prospection/recherches/${id}`),

  // Prospects
  updateProspect: (id, data) => api.put(`/prospection/prospects/${id}`, data),
  deleteProspects: (ids) => api.delete('/prospection/prospects', { data: { ids } }),

  // Enrichissement
  enrich: (id) => api.post(`/prospection/prospects/${id}/enrich`),
  enrichBulk: (ids) => api.post('/prospection/prospects/enrich-bulk', { ids }),
  getEnrichissements: (id) => api.get(`/prospection/prospects/${id}/enrichissements`),
  getQuota: () => api.get('/prospection/enrich-quota'),

  // Export
  exportCSV: (rechercheId) => api.get(`/prospection/export/${rechercheId}`, { responseType: 'blob' }),
  exportXLSX: (rechercheId) => api.get(`/prospection/export-xlsx/${rechercheId}`, { responseType: 'blob' }),
};

export default prospectionApi;
